import React from 'react';
import _, { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { DevelopmentBlock } from './styles/NewDevelopmentBlock.styled';
import { Container } from './styles/Container.styled';
import { SectionHeadline } from './styles/SectionHeadline.styled';
import { Link } from './styles/Link.styled';
import { VisitServiceColumn } from './styles/VenueServiceTextImage.styled';
import { Row } from './styles/Row.styled';
import { ColumnXlSevenLgSix, Column, Innercontent } from './styles/Column.styled';
import { Button, ButtonDiv } from './styles/Button.styled';
import { DWTCContext } from '../utils/context';
import Sprites from './Sprites';

export default function NewDevelopment({ data, id, dir }) {
  const {
    title,
    viewAllLink,
    developmentImage,
    developmentTitle,
    developmentText,
    developmentWebsite,
  } = data;
  const { cssClass } = React.useContext(DWTCContext);

  const getTheme = () => {
    if (_.includes(cssClass, 'free-zone')) return '#ce445b';
    if (_.includes(cssClass, 'real-estate')) return '#1ba39c';
    return '#1b7bdd';
  };

  return (
    <>
      <DevelopmentBlock id={id}>
        <Container>
          <SectionHeadline className="newdevelopment" dir={dir}>
            <h2 dir={dir}>{title}</h2>
            <Link
              dir={dir}
              href={viewAllLink ? viewAllLink.url : '#0'}
              aria-label="View All"
              color={getTheme()}
              className="home_link"
            >
              <span>{viewAllLink.name}</span> <Sprites name="arrow" className="arrow" />
            </Link>
          </SectionHeadline>
        </Container>
      </DevelopmentBlock>

      <VisitServiceColumn className="new_developmentcontent">
        <Container>
          <Row className="right">
            <Column>
              <Innercontent className="newdevelopmentcontent" dir={dir}>
                <h3 dir={dir}>{developmentTitle}</h3>
                <p>{developmentText}</p>
                <ButtonDiv className="new_developmentbutton" dir={dir}>
                  <Button
                    stylevariant="greentransparent"
                    href={developmentWebsite ? developmentWebsite.url : '#0'}
                    target={developmentWebsite.target}
                    rel=""
                    dir={dir}
                  >
                    {developmentWebsite.name}
                  </Button>
                </ButtonDiv>
              </Innercontent>
            </Column>
            <ColumnXlSevenLgSix>
            {isEmpty(developmentImage) || (
              <LazyLoadImage
                src={developmentImage.url}
                alt={developmentTitle}
                effect="blur"
                placeholderSrc={
                  developmentImage ? `${developmentImage.url}?width=50&quality=50` : null
                }
              />
            )}
              
              <ButtonDiv className="new_developmentbutton_sv">
                <Button
                  stylevariant="greentransparent"
                  href={developmentWebsite ? developmentWebsite.url : '#0'}
                  target={developmentWebsite.target}
                  rel=""
                  dir={dir}
                >
                  {developmentWebsite.name}
                </Button>
              </ButtonDiv>
            </ColumnXlSevenLgSix>
          </Row>
        </Container>
      </VisitServiceColumn>
    </>
  );
}
